import immutableUpdate from 'react-addons-update';
import moment from 'moment';
import {
  SET_ORDER_DETAILS,
  SET_SELECTED_OPTION,
  SET_SELECTED_VARIANT,
  SET_SELECTED_LOCATION,
  SET_SELECTED_RESOURCE,
  SET_TIMESLOT,
  SET_DATE_RANGE,
  SET_SELECTED_TERM,
  SET_BOOKING_FIELDS,
  SET_BOOKINGS,
  CHANGE_ADDITIONAL_DETAILS,
  ADD_REPEATED_FIELD_ITEMS,
  REMOVE_REPEATED_FIELD_ITEMS,
  SET_ADDITIONAL_DETAILS_VALIDATION_ERRORS
} from '../actions/orders';

const initialState = {
  totalPrice: 0,
  date: null,
  available: 0,
  quantity: 1,
  totalQuantity: 0,
  variants: {},
  timeSlot: null,
  selectedTimeslot: null,
  variantSelected: null,
  selectedLocation: null,
  selectedResource: null,
  termSelected: {},
  bookingFields: [],
  bookings: [],
  additionalDetails: {},
  additionalDetailsValidationErrors: [],
  currentMonth: moment(Date.now()).startOf('month'),
};

export default function orderReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ORDER_DETAILS:
      return {
        ...state,
        ...action.value,
      };

    case SET_SELECTED_OPTION:
      return immutableUpdate(state, {
        selectedTimeslot: { $set: action.value },
      });

    case SET_SELECTED_VARIANT:
      return immutableUpdate(state, {
        variantSelected: { $set: action.value },
      });

    case SET_SELECTED_LOCATION:
      return immutableUpdate(state, {
        selectedLocation: { $set: action.value },
      });

    case SET_SELECTED_RESOURCE:
      return immutableUpdate(state, {
        selectedResource: { $set: action.value },
      });

    case SET_SELECTED_TERM:
      return immutableUpdate(state, {
        termSelected: { $set: action.value },
      });

    case SET_TIMESLOT:
      return immutableUpdate(state, {
        timeSlot: { $set: action.value },
      });
    case SET_DATE_RANGE:
      return immutableUpdate(state, {
        dateRange: { $set: action.value },
      });
    case SET_BOOKING_FIELDS:
      return immutableUpdate(state, {
        bookingFields: { $set: action.value },
      });
    case CHANGE_ADDITIONAL_DETAILS:
      if (action.field.repeated && action.index != null) {
        const values = state.additionalDetails[action.field.key];
        values[action.index] = action.value;
        return immutableUpdate(state, {
          additionalDetails: {
            [action.field.key]: { $set: values },
          }, additionalDetailsValidationErrors: {
            $set: state.additionalDetailsValidationErrors.map(error => error.key == `${action.field.key}-${action.index}` ?
                {...error, fieldChanged: true} : error
              )
            }
          }
        );
      }
      return immutableUpdate(state, {
        additionalDetails: {
          [action.field.key]: {$set: action.value},
        },
        additionalDetailsValidationErrors: {
          $set: state.additionalDetailsValidationErrors.map(error => error.key == `${action.field.key}` ?
            {...error, fieldChanged: true} : error
        )
      }
    });
    case ADD_REPEATED_FIELD_ITEMS:
      var details = Object.assign({}, state.additionalDetails);
      var fieldsSettings = action.fieldsSettings || [];
        fieldsSettings.forEach((field) => {
          if (field.repeated) {
          if (!details[field.key]) details[field.key] = [];
          details[field.key].push('');
        }
      });
      return immutableUpdate(state, {
        additionalDetails: { $set: details },
      });
    case REMOVE_REPEATED_FIELD_ITEMS:
      var details = Object.assign({}, state.additionalDetails);
      var fieldsSettings = action.fieldsSettings || [];
      fieldsSettings.forEach((field) => {
          if (field.repeated) {
          if (!details[field.key]) details[field.key] = [];
          details[field.key].splice(action.index, 1);
        }
      });
      return immutableUpdate(state, {
        additionalDetails: { $set: details },
      });
    case SET_ADDITIONAL_DETAILS_VALIDATION_ERRORS:
      return immutableUpdate(state, {
        additionalDetailsValidationErrors: { $set: action.errors },
      });
    default:
      return state;
  }
}
